import script from "./FamilyGroupPotentialMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyGroupPotentialMember.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyGroupPotentialMember.vue?vue&type=style&index=0&id=0868930e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0868930e"]])

export default __exports__